import { useQuery } from "@tanstack/react-query";

import type { UUID } from "@/core/types";

import { usePatientConsentsKey } from "../keyFactory";
import { getPatientConsents } from "../queryFunctions/getPatientConsents";

export function usePatientConsents(patientId: UUID) {
  return useQuery({
    enabled: !!patientId,
    queryFn: () => getPatientConsents(patientId),
    queryKey: usePatientConsentsKey.list(patientId),
    refetchOnWindowFocus: true,
  });
}
